/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 10:00:36 
 * @Last Modified by:   jingyu.yang 
 * @Last Modified time: 2021-12-17 10:00:36 
 */
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["selfParticipant"]),
    // 1：嘉宾 2：助手 3:主播 4:指定嘉宾
    role() {
      return this.selfParticipant?.type;
    },
    //演示权： 1：有  0：无
    share() {
      return this.selfParticipant?.share
    },
    // 主控权   1：有  0：无
    avctl() {
      return this.selfParticipant?.avctl
    },
  }
}